import { Stack } from "@mui/material"
import { AuthorChip } from "features/article/components/authorChip"
import { ArticleResult } from "interface/article"

type ArticlesAuthorListProps = {
	article: ArticleResult
	targetSisetuCode?: string
	targetKojinCode?: string
	targetAuthorId?: number
	onKojinOpen?: (kojinCode: string) => void
	onAuthorOpen?: (authorId: number) => void
}
export const ArticlesAuthorList = ({
	article,
	targetSisetuCode,
	targetKojinCode,
	targetAuthorId,
	onKojinOpen,
	onAuthorOpen
}: ArticlesAuthorListProps) => {
	return (article.authors && article.authors.length > 0) ? (
		<Stack direction="row" spacing={0.5} justifyContent='flex-end' alignItems='center' flexWrap='wrap' useFlexGap>
			{article.authors.map((author, i) => (
				<AuthorChip
					key={`author-${article?.articleId}-${i+1}`}
					author={author}
					targetSisetuCode={targetSisetuCode}
					targetKojinCode={targetKojinCode}
					targetAuthorId={targetAuthorId}
					onClick={() => {
						if (author.kojinCode && onKojinOpen) {
							onKojinOpen(author.kojinCode)
						} else if (author.authorId && onAuthorOpen) {
							onAuthorOpen(author.authorId)
						}
					}}
				/>
			)) }
		</Stack>
	) : <></>
}